module.exports = __webpack_public_path__ + "static/media/C026.79ab9160.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/carousel/C026.jpg
// module id = 309
// module chunks = 0